import React, { useState, useEffect, useRef } from 'react';

const RetryableImage = ({ src, alt, maxRetries = 3, retryDelay = 3000, ...props }) => {
  const [attempt, setAttempt] = useState(0);
  const [imgSrc, setImgSrc] = useState('');
  const [error, setError] = useState(false);
  const retryTimeout = useRef(null);
  console.log("retryDelay", retryDelay);

  useEffect(() => {
    // Reset state when src changes
    setAttempt(0);
    setError(false);
    setImgSrc(src); // Don't add retry param initially
  }, [src]);

  useEffect(() => {
    // Clean up any pending timeouts on unmount
    return () => {
      if (retryTimeout.current) {
        clearTimeout(retryTimeout.current);
      }
    };
  }, []);

  const handleLoad = () => {
    // If image loads successfully, cancel any future retries
    if (retryTimeout.current) {
      clearTimeout(retryTimeout.current);
    }
  };

  const handleError = () => {
    console.log("handleError", attempt, maxRetries);
    if (attempt < maxRetries) {
      retryTimeout.current = setTimeout(() => {
        setAttempt(prev => prev + 1);
        // Add retry param to bypass browser cache
        setImgSrc(`${src}?retry=${Date.now()}`);
      }, retryDelay);
    } else {
      setError(true);
    }
  };

  return error ? (
    <div style={{ color: 'red' }}>Failed to load image after {maxRetries} attempts.</div>
  ) : (
    <img
      src={imgSrc}
      alt={alt}
      onError={handleError}
      onLoad={handleLoad}
      style={{ width: '100%', height: '250px', objectFit: 'contain' }}
      {...props}
    />
  );
};

export default RetryableImage;
